import axios from "axios";

export class DisbursementRequestListService {
  constructor() {}

  getAllDisbursementData(filterCondition) {
    return axios.post("/disbursement/getAllDisbursementData", filterCondition);
  }

  getDisbursementData(data) {
    return axios.post("/disbursement/getDisbursementData", data);
  }

  getDisbursementDataByBranch(branch) {
    return axios.post("/disbursement/searchAllDisbBranchData", {
      branch: branch.label,
      branchCode: branch.code,
    });
  }
}
